import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../api.ts';
import { Notice, Loading } from '../components/Bits.tsx';

/**
 * Unsubscribe from a link in an email.
 *
 * Deliberately outside the signed-in area. An unsubscribe that asks for a password is one
 * people cannot use, and they report the message as spam instead.
 */
export function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState<'working' | 'done' | 'failed'>('working');

  useEffect(() => {
    if (!token) { setState('failed'); return; }
    api.post(`/api/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(() => setState('done'))
      .catch(() => setState('failed'));
  }, [token]);

  return (
    <main className="narrow" id="main">
      <h2>Email preferences</h2>

      {state === 'working' && <Loading what="Updating your preferences" />}

      {state === 'done' && (
        <>
          <Notice kind="ok">
            You have been unsubscribed. You will not receive any more email about the SEED
            Scholarship.
          </Notice>
          <p className="hint">
            This does not affect your application, and it does not close your account. You will
            still receive a message if you reset your password or submit an application, because
            those are replies to something you did.
          </p>
          <p><Link to="/">Go to the scholarship application</Link></p>
        </>
      )}

      {state === 'failed' && (
        <>
          <Notice kind="error">
            That unsubscribe link is not valid. It may have been copied incompletely from the
            email.
          </Notice>
          <p className="hint">
            Contact the foundation and we will remove you by hand.
          </p>
        </>
      )}
    </main>
  );
}
